// extracted by mini-css-extract-plugin
export default {"headerRow":"headerRow--DiFO8"};